<template>
  <div>
    <Card>
      <template #title>Займы</template>
      <template #content>
        <AbstractTable
            ref="table"
            code="loansByCorrectionReport"
            :default-data="defaultData"
            display-filter="menu"
        >
          <template #loanId="row">
            <div>
              <IdChip
                  :id="row.data.loanId"
                  view="loan_view"
                  toast-template='Идентификатор займа "{v}" скопирован'
              />
            </div>
          </template>
          <template #cbUuid="row">
            <ValueChip
                :value="row.data.cbUuid"
                toast-template='UUID займа "{v}" скопирован'
            />
          </template>
        </AbstractTable>
      </template>
    </Card>
  </div>
</template>

<script>
import AbstractTable from "@/components/AbstractTable";
import ValueChip from "@/components/Common/ValueChip.vue";
import IdChip from "@/components/Common/IdChip.vue";
export default {
  name: "CorrectionReportLoansTable",
  components: { IdChip, ValueChip, AbstractTable},
  props: {
    defaultData: {
      type: Object,
      default: () => null
    }
  }
}
</script>

<style scoped>

</style>